import React from 'react';
import {reduxForm} from 'redux-form';
import BaseForm from '../form/base-form';
import FormField from '../form/form-field';
import DateField from '../form/date-field';
import LocalizedStrings from '../../localization/strings';
import Button from '../button';
import {validateRequiredFields} from '../../utils/form';
import Alert from '../alert';

const fields = [
    'id',
    'first_name',
    'last_name',
    'birth_date',
    'row', 'titles'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'first_name',
        'last_name',
        'birth_date', 'row', 'titles'

    ], errors);
    return errors;
}

class ParticipantResultForm extends BaseForm {
    showAlert() {
        const {
            showAlert = true
        } = this.props;

        return showAlert;
    }


    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                first_name,
                last_name,
                birth_date,
                row,
                titles

            }
        } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    <div className="form-row">
                        <FormField label={LocalizedStrings.firstName} name="name" field={first_name}>
                            <input ref="name" placeholder={LocalizedStrings.firstName} type="text" {...first_name}/>
                        </FormField>

                        <FormField label={LocalizedStrings.lastName} name="last_name" field={last_name}>
                            <input ref="last_name" placeholder={LocalizedStrings.lastName} type="text" {...last_name}/>
                        </FormField>
                        <FormField label={LocalizedStrings.birthDate} name="birth_date" field={birth_date}>
                            <DateField {...birth_date} timeFormat={false} noTimeZoneDate={true}
                                       viewMode="years"></DateField>
                        </FormField>
                    </div>
                    <FormField label={LocalizedStrings.result} name="row" field={row}>
                        <textarea ref="row" placeholder={LocalizedStrings.result} {...row}/>
                    </FormField>

                    <FormField label={LocalizedStrings.titles} name="titles" field={titles}>
                        <textarea ref="titles" placeholder={LocalizedStrings.titles} {...titles}/>
                    </FormField>

                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting} type="main-color">
                            {LocalizedStrings.submit}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'participant--result-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({
    initialValues: state.admin.participant.participant_result.item
}))(ParticipantResultForm);



// WEBPACK FOOTER //
// ./src/js/components/participant/participant-result-form.js